'use client';

import { AnimatedLink } from '@/components/AnimatedLink';
import BlogArticleList from '@/components/HomeBlogArticlesList';
import { IBlogDictionary } from '@/dictionaries/pages/blog/types';
import { IHomeDictionary } from '@/dictionaries/pages/home/types';
import { HomeTranslatedBlogArticle } from '@/types/Blog';
import parser, {
  DOMNode,
  domToReact,
  HTMLReactParserOptions,
} from 'html-react-parser';
import Link from 'next/link';

type IHomeTravelJournalProps = {
  dict: IHomeDictionary;
  blogDict: IBlogDictionary;
  articles: HomeTranslatedBlogArticle[];
  lang: Locale;
};

export function HomeTravelJournal({
  dict,
  blogDict,
  articles,
  lang,
}: IHomeTravelJournalProps) {
  const parseOptions: HTMLReactParserOptions = {
    replace: (node, index) => {
      if (node.type === 'tag' && node.name === 'a' && node.children) {
        const href = node.attribs?.href || '/';
        return (
          <Link
            className="styled-link"
            href={lang === 'en' ? `${href || '/'}` : `/${lang}${href || '/'}`}
            key={index}>
            <strong>
              {domToReact(node.children as DOMNode[], parseOptions)}
            </strong>
          </Link>
        );
      }
    },
  };

  const articlesSplit = articles.slice(0, 3);

  return (
    <section className="max-w-default mx-auto py-32">
      <h2 className="text-title font-title font-bold w-full text-center">
        {parser(dict.travel.title, parseOptions)}
      </h2>
      <p className="mt-5 mb-20 text-gray-900 leading-[1.5] text-body text-center max-w-[90%] mx-auto">
        {parser(dict.travel.description, parseOptions)}
      </p>

      <BlogArticleList dict={blogDict} lang={lang} articles={articlesSplit} />

      <div className="flex justify-center">
        <AnimatedLink
          className="w-fit py-[20px] px-[10px] mt-[30px] desktop:px-[40px] desktop:w-fit"
          target="_blank"
          href={dict.travel.cta.href}>
          <div>{dict.travel.cta.title}</div>
        </AnimatedLink>
      </div>
    </section>
  );
}
